import {
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	FieldLayout,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, JSX, useEffect, useState } from "react";
import Select, { GroupBase, OptionProps, components } from 'react-select'

import { Box } from "@mui/material";
import { accountTypeDDL } from "../../../../common/Common";

export interface MenuOption {
	label: string;
	value: string;
	slug: string;
	parentId?: string;
}
export const convertMenuHeadTreeDDLData = (data: any[]) => {
	const result: any[] = [];

	data.forEach((item) => {
		const { options, ...parent } = item;

		// push parent without options
		result.push(parent);

		// if options exist, push them with parentId
		if (options && options.length > 0) {
			options.forEach((child: any) => {
				result.push({
					...child,
					parentId: item.value,
				});
			});
		}
	});

	result.unshift({
		label: "--",
		value: null,
	});

	return result;
};

interface IScreenInfoSetupFieldsPanel { parentLabelsDDL: any, formMethods: any }
export const ScreenInfoSetupFieldsPanel: FC<
	IScreenInfoSetupFieldsPanel
> = ({ parentLabelsDDL, formMethods }) => {
	const [menuHeadDDL, setMenuHeadDDL] = useState<MenuOption[]>([]);

	// const data = [
	// 	{
	// 		"label": "Home",
	// 		"value": "695cdf1ee18e1a110929b0b4",
	// 		"slug": "home",
	// 		options: [
	// 			{
	// 				"label": "Global Search",
	// 				"value": "695cdf7ce18e1a110929b0789",
	// 				"slug": "g-s",
	// 			}
	// 		]
	// 	},
	// 	{
	// 		"label": "Compliance",
	// 		"value": "695cdf7ce18e1a110929b0be",
	// 		"slug": "compliance",
	// 		options: [
	// 			{
	// 				"label": "T4",
	// 				"value": "695cdf7ce18e1a110929b022",
	// 				"slug": "t4"
	// 			},
	// 			{
	// 				"label": "RL-1",
	// 				"value": "695cdf7ce18e1a110929b0b33",
	// 				"slug": "rl1"
	// 			},
	// 		],
	// 	}
	// ]

	useEffect(() => {
		if (parentLabelsDDL) {
			const ddl = convertMenuHeadTreeDDLData(parentLabelsDDL)
			setMenuHeadDDL(ddl)
		}
	}, [parentLabelsDDL])

	const customStyles = {
		control: (provided: any, state: { isDisabled: any; }) => {
			return ({
				...provided,
				backgroundColor: state.isDisabled ? 'rgba(0, 0, 0, 0.06)' : '#fff',
				borderColor: '#c3c4c4',
				minHeight: '3em',
				borderRadius: "2px !important",
				marginBottom: "35px",
				// height: '3em',
				// boxShadow: state.isFocused ? null : null,
				":hover": {
					borderColor: '#000'
				},
			})
		},
		container: (provided: any) => ({
			...provided,
			fontFamily: ["Roboto", "sans-serif"].join(","),
			fontSize: ".8125rem",
			fontWeight: 500,
			lineHeight: "1rem",
		}),
	};
	// const getItems = (
	// 	options: any[],
	// 	isEmpty?: Boolean,
	// 	multiEnable?: Boolean
	// ) => {
	// 	if (
	// 		isEmpty &&
	// 		options &&
	// 		options.length > 0 &&
	// 		options[0].value !== "" &&
	// 		!multiEnable
	// 	) {
	// 		let emptyOption = { value: "", label: "--" };
	// 		options.splice(0, 0, emptyOption);
	// 	}
	// 	options.map((item, index) => ({
	// 		index: item.value,
	// 		value: {
	// 			...item,
	// 			toString: () => index, // assumes item has a unique id property
	// 		},
	// 		label: item.label,
	// 	}));
	// };


	const getItems = (options: any[]) => {
		return options.map((item, index) => ({
			...item,
			value: item.value,
			label: item.label,
		}));
	};

	const Option = (props: JSX.IntrinsicAttributes & OptionProps<unknown, boolean, GroupBase<unknown>> | any) => {
	
		return (
			<div>
				<components.Option {...props}>
					<label style={{ fontWeight: !props.data.parentId ? "bold" : "normal", marginLeft: props.data.parentId ? "1.5rem" : 0 }}>{props.label}</label>
				</components.Option>
			</div>
		);
	};

	const onHeadSelectionChangeHandler = (selected: any) => {
		formMethods.setValue("menuParentId", selected.value);
	};

	const selectedValue = formMethods.watch("menuParentId");

	const getSingleSelectValue = (options: any[]) => {
		if (!selectedValue) return null;

		return options.find((option) => {
			return option && option.value === selectedValue;
		});
	};
	return (
		<Box>
			<RHookFormTextFieldWithLabel
				label="Name"
				id="name"
				testId={`name`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="URL"
				id="url"
				testId={`url`}
				labelPosition={LabelPosition.Top}
			/>
			{/* <EnhancedDropDownRHFWithLabel
				label="Menu Head"
				selectName="menuParentId"
				testId={`menuHead`}
				labelPosition={LabelPosition.Top}
				items={parentLabelsDDL ?? []}
			/> */}
			<FieldLayout
				label="Menu Head"
				testId="menu-head"
			>
				<Select
					id="menuParentId"
					{...formMethods.register("menuParentId")}
					// value={formMethods.watch("menuParentId")?.value || undefined}
					value={getSingleSelectValue(menuHeadDDL)}
					onChange={onHeadSelectionChangeHandler}
					options={getItems(menuHeadDDL)}
					styles={customStyles}
					hideSelectedOptions={false}
					components={{
						Option,
						IndicatorSeparator: () => null,
					}}
				/>
			</FieldLayout>
			<RHookFormTextFieldWithLabel
				label="Sequence"
				id="menuOrder"
				testId={`sequence`}
				labelPosition={LabelPosition.Top}
			/>
			{/* <EnhancedIOSSwitchRHFWithLabel
				name="isAdmin"
				checked={false}
				testId="isOwner"
				label="IsOwner"
				labelPosition={LabelPosition.Top}
			/> */}
			<EnhancedDropDownRHFWithLabel
				label="Account Type"
				selectName="accountType"
				testId={`account-type`}
				labelPosition={LabelPosition.Top}
				items={accountTypeDDL ?? []}
				selectedItem={200}
			/>
		</Box>
	);
};
